import actions from './actions';

const { openAppDrawer, closeAppDrawer } = actions;

export default {
  openAppDrawer,
  closeAppDrawer,
};
